import { render } from "./RecentPayment.vue?vue&type=template&id=6a82c4e3&scoped=true&ts=true"
import script from "./RecentPayment.vue?vue&type=script&lang=ts"
export * from "./RecentPayment.vue?vue&type=script&lang=ts"

import "./RecentPayment.vue?vue&type=style&index=0&id=6a82c4e3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a82c4e3"]])

export default __exports__